/**
 * Practice NAP (Name / Address / Phone) — single source of truth.
 * Every schema, footer, contact block and citation MUST read from here.
 */

export const PRACTICE = {
  name: 'Restore.Dental',
  alternateName: 'Restore Dental',
  tagline: 'Restoring Smiles, Restoring Confidence, with gentle modern dentistry',
  dentistName: 'Dr. Kartik Patel',
  dentistQualifications: 'BDS (King\'s College London)',
  gdcNumber: '177993',
  phoneDisplay: '07787 814 064',
  phoneE164: '+447787814064',
  phoneTel: 'tel:+447787814064',
  whatsappNumber: '447787814064',
  email: 'hello@restore.dental',
  address: {
    street: '64a Horn Lane',
    locality: 'Acton',
    region: 'London',
    postcode: 'W3 6NP',
    country: 'GB',
  },
  addressOneLine: '64a Horn Lane, Acton, London W3 6NP',
  geo: { lat: 51.5110, lng: -0.2710 },
  openingHours: [
    { days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], label: 'Monday – Friday', opens: '09:00', closes: '18:00' },
    { days: ['Saturday'], label: 'Saturday', opens: '09:00', closes: '14:00' },
  ],
  closedDays: ['Sunday'],
  transport: [
    { name: 'Acton Main Line', lines: 'Elizabeth line & GWR', walk: '4 min walk' },
    { name: 'Acton Central', lines: 'London Overground (Mildmay line)', walk: '9 min walk' },
    { name: 'Acton Town', lines: 'Piccadilly & District lines', walk: '15 min walk / 5 min bus' },
  ],
  parking: 'Pay-and-display parking on Horn Lane and surrounding streets; Morrisons Acton car park 3 min walk.',
  links: {
    googleMaps: 'https://www.google.com/maps/place/Restore.Dental+%7C+Dr.+Kartik+Patel+%7C+West+London+Invisalign/@51.514787,-0.275029,15z/data=!4m6!3m5!1s0x48760fbb2777c9ad:0xccd55a940edf434d!8m2!3d51.514787!4d-0.275029!16s%2Fg%2F11j62n_f9b',
    googleBusinessProfile: 'https://share.google/leS1EveQLTHoqffLT',
    instagram: 'https://www.instagram.com/kartikpateldentist/',
    facebook: 'https://www.facebook.com/profile.php?id=61588647254315',
    gdcRegister: 'https://olr.gdc-uk.org/SearchRegister/SearchResult?RegistrationNumber=177993',
  },
};

export const WHATSAPP_LINK = `https://wa.me/${PRACTICE.whatsappNumber}?text=${encodeURIComponent('Hello! I would like to book an appointment at restore.dental')}`;

export const getSameAsLinks = () => [
  PRACTICE.links.googleBusinessProfile,
  PRACTICE.links.googleMaps,
  PRACTICE.links.instagram,
  PRACTICE.links.facebook,
];

export const getOpeningHoursSpecification = () =>
  PRACTICE.openingHours.map((h) => ({
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: h.days,
    opens: h.opens,
    closes: h.closes,
  }));

export const getPostalAddress = () => ({
  '@type': 'PostalAddress',
  streetAddress: PRACTICE.address.street,
  addressLocality: PRACTICE.address.locality,
  addressRegion: PRACTICE.address.region,
  postalCode: PRACTICE.address.postcode,
  addressCountry: PRACTICE.address.country,
});

export const getGeo = () => ({
  '@type': 'GeoCoordinates',
  latitude: PRACTICE.geo.lat,
  longitude: PRACTICE.geo.lng,
});
